<template>
  <Modal
    v-model="visible"
    :width="600"
    title="找回密码"
    class="enterprise-modal"
    :mask-closable="false"
  >
  <Form ref="form" :label-width="100" :model="form" :rules="rules" autocomplete="off">
    <FormItem label="手机号" :prop="isLogin ? 'mobile' : ''">
      <Input type="tel" maxlength="11" v-model="mobile" autocomplete="off" disabled v-if="!isLogin"/>
      <Input type="tel" maxlength="11" v-model="form.mobile" autocomplete="off" v-else />
    </FormItem>
    <FormItem label="验证码"  prop="code">
      <Input type="text" v-model="form.code" style="width: 75%;" autocomplete="off" />
      <Button type="primary" @click="handleSendCode" style="margin-left: 10px;">{{ buttonText  }}</Button>
    </FormItem>
    <FormItem label="新密码"  prop="password">
      <Input type="password" maxlength="8" v-model="form.password" autocomplete="new-password" />
    </FormItem>
    <FormItem label="确认密码"  prop="confirmPassword">
      <Input type="password" maxlength="8" v-model="form.confirmPassword" autocomplete="new-password" />
    </FormItem>
  </Form>
  <div slot="footer">
      <Button :loading="sureLoading" type="primary" @click="handleSure">
        确认提交
      </Button >
    </div>
  </Modal>
</template>
<script>
import { validatesmscode, sendsmscode, findpassword } from '@/api/index'
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sureLoading: false,
      visible: false,
      buttonText: '获取验证码',
      rules: {
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur',
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value &&
                value !== '' &&
                value.trim() !== '' &&
                (value.length < 11 || !/^1[3456789]\d{9}$/.test(Number(value)))
              ) {
                callback(new Error('请输入正确的手机号码'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          }
        ],
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: '请输入新密码',
            trigger: 'blur',
          },
          {
            type: 'string',
            min: 6,
            message: '密码不能少于6位数',
            trigger: 'blur',
          },
          {
            type: 'string',
            max: 8,
            message: '密码不能大于8位数',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: '请再次确认密码',
            trigger: 'blur',
          },
          {
            type: 'string',
            min: 6,
            message: '密码不能少于6位数',
            trigger: 'blur',
          },
          {
            type: 'string',
            max: 8,
            message: '密码不能少于6位数',
            trigger: 'blur',
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (
                value &&
                value !== '' &&
                value.trim() !== '' &&
                value !== this.form.password
              ) {
                callback(new Error('两次输入密码必须一致'))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
      form: {
        mobile: '',
        code: null,
        validateCode: null,
        password: null,
        confirmPassword: null,
      }
    }
  },
  computed: {
    mobile() {
      return this.$store.state.userInfo.account
    }
  },
  watch: {
    visible() {
      this.form = this.$options.data().form
      this.$refs.form.resetFields()
    }
  },
  methods: {
    async handleSendCode() {
      let mobile = this.mobile
      if (this.isLogin) {
        mobile = this.form.mobile
        if (this.form.mobile.length < 11 || !/^1[3456789]\d{9}$/.test(Number(this.form.mobile))) {
          this.$Message.warning('手机号格式不正确')
          return
        }
      }
      if (this.buttonText === '获取验证码' || this.buttonText === '重新获取') {
        try {
          this.sendLoading = true
          await sendsmscode({
            mobile
          })
          this.sendLoading = false
          let count = 30
          this.buttonText = count + 'S'
          let timer = setInterval(() => {
            count--
            this.buttonText = count + 'S'
            if (count === 0) {
              clearInterval(timer)
              this.buttonText = '重新获取'
            }
          }, 1000)
        } catch (error) {
          this.sendLoading = false
        }
      }
    },
    handleSure() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.sureLoading = true
            let sendData = {
              ...this.form
            }
            if (!this.isLogin) {
              sendData.mobile = this.mobile
            }
            let res = await validatesmscode({
              mobile: sendData.mobile,
              code: this.form.code
            })
            sendData.validateCode = res
            await findpassword(sendData)
            this.sureLoading = false
            this.$Message.success('设置成功')
            this.visible = false
          } catch (error) {
            this.sureLoading = false
          }
        }
      })
    }
  }
}
</script>
